import { useEffect, useState } from "react";
import styles from "../onboard.module.css";
import { Row, Card, Col, Spinner, Modal, Button } from "react-bootstrap";
import { onBoardPersonalDetail } from "../../../api";
import { useMyContext } from "../../../myContext";
import AddIcon from "../../common/AddIcon";
import VisitedRemitter from "./visitedRemitter";
import greentickmark from "../../signup/assets/greenTickIcon.svg";
import RemitterForm from "./remitterForm";
import cross from "../../../public/assets/closeIcon.svg";
import SearchableDropdown from "../../common/SearchableDropdown";

const RemitterPersonalDetail = ({
  setReqDocs,
  stepToShow,
  setStepsToShow,
  remitterList,
  setFilteredList,
  shortDetail,
  setShortDetail,
  remitterLoader,
  setShowRemitterBankDetail,
  showRemitterDetail,
  setShowRemitterDetail,
  setKycLoader,
  setErrorStatus,
  remitterCardSelection,
  setRemitterCardSelection,
  addnewButton,
  fetchCardDetail,
}) => {
  const [displayRemitterList, setDisplayRemitterList] = useState(remitterList);
  const [clearSelectionTrigger, setClearSelectionTrigger] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");
  // const [studentRelationship, setStudentRelationship] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [dob, setDob] = useState("");
  const [loading, setLoading] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNoError, setPhoneNoError] = useState("");
  const [panError, setPanError] = useState("");
  const [postalError, setPostalError] = useState("");
  const [nextSectionError, setNextSectionError] = useState("");
  const [dobError, setDobError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [valid, setIsValid] = useState({
    name: false,
    email: false,
    phoneNumber: false,
    panNumber: false,
    // studentRelationship: false,
    postalCode: false,
    address: false,
    city: false,
    state: false,
    selectedDocument: false,
    aadhaarNo: false,
    nameOnPassport: false,
    passportNo: false,
    passportIssueDate: false,
    passportExpiryDate: false,
    placeOfIssue: false,
  });

  const [selectedDocument, setSelectedDocument] = useState(null);
  const [aadhaarNo, setAadhaarNo] = useState("");
  const [aadhaarError, setAadhaarError] = useState("");
  const [passportNo, setPassportNo] = useState("");
  const [passportNoError, setPassportNoError] = useState("");
  const [nameOnPassport, setNameOnPassport] = useState("");
  const [nameOnPassportError, setNameOnPassportError] = useState("");
  const [passportIssueDate, setPassportIssueDate] = useState("");
  const [passportIssueDateError, setPassportIssueDateError] = useState("");
  const [passportExpiryDate, setPassportExpiryDate] = useState("");
  const [passportExpiryDateError, setPassportExpiryDateError] = useState("");
  const [placeOfIssue, setPlaceOfIssue] = useState("");
  const [placeOfIssueError, setPlaceOfIssueError] = useState("");
  const [selectedDocumentError, setSelectedDocumentError] = useState("");

  const {
    upadteUserId,
    remitterSecondFlow,
    setRemitterSecondFlow,
    setRemitterBankSecondFlow,
    setRemitterBankCardSelection,
    setSelectedRemitterBank,
    setCompletedRemitter,
    setShowKycDetail,
    setShowKyc,
    themeColor,
  } = useMyContext();

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setDisplayRemitterList(remitterList);
  }, [remitterList]);

  // const handleChangeOption = (value) => {
  //   setStudentRelationship(value);
  // };

  const onHandleDate = (date, field) => {
    const dateObject = new Date(date);
    const formattedDate = dateObject.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    if (field === "dateofbirth") {
      setDob(formattedDate);
    }
    if (field === "passportIssueDate") {
      setPassportIssueDate(formattedDate);
    }
    if (field === "passportExpiryDate") {
      setPassportExpiryDate(formattedDate);
    }
  };

  const ValidateEmail = (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      setEmailError("");
      return false;
    } else {
      return true;
    }
  };

  const validatePan = (panNumber) => {
    const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    if (panPattern.test(panNumber)) {
      return true;
    } else {
      return false;
    }
  };

  const validateAadhaar = (aadhaarNumber) => {
    // Aadhaar should be exactly 12 digits
    const aadhaarPattern = /^[0-9]{12}$/;
    return aadhaarPattern.test(aadhaarNumber);
  };

  const validatePassportNo = (passportNumber) => {
    // Indian passport format: 1 letter + 7 digits, or new format: 2 letters + 6 digits
    const passportPattern = /^([A-Z][0-9]{7}|[A-Z]{2}[0-9]{6})$/;
    return passportPattern.test(passportNumber);
  };

  const validatePassportDates = (issueDate, expiryDate) => {
    if (!issueDate || !expiryDate) return false;
    const issue = new Date(parseDate(issueDate));
    const expiry = new Date(parseDate(expiryDate));
    const today = new Date();

    // Issue date should be in the past, expiry date should be in the future
    return issue < today && expiry > today && issue < expiry;
  };

  const parseDate = (value) => {
    const [day, month, year] = value.split("/");
    return `${year}/${month}/${day}`;
  };

  const handleBlur = (e) => {
    if (e.target.name === "email") {
      if (ValidateEmail() && email !== "") {
        setIsValid({ ...valid, email: true });
        setEmailError("Enter a valid email such as example@email.com");
      } else {
        setEmailError("");
        setIsValid({ ...valid, email: false });
      }
    } else if (e.target.name === "phoneNumber") {
      if (phoneNumber !== "" && phoneNumber.length < 10) {
        setIsValid({ ...valid, phoneNumber: true });
        setPhoneNoError("Phone Number should be 10 digit.");
      } else {
        setIsValid({ ...valid, phoneNumber: false });
        setPhoneNoError("");
      }
    } else if (e.target.name === "PAN") {
      if (panNumber !== "" && !validatePan(panNumber)) {
        setIsValid({ ...valid, panNumber: true });
        setPanError("Enter a valid panNumber such as IFYTS7685M");
      } else {
        setIsValid({ ...valid, panNumber: false });
        setPanError("");
      }
    } else if (e.target.name === "Postal") {
      if (postalCode !== "" && postalCode.length < 6) {
        setIsValid({ ...valid, postalCode: true });
        setPostalError("Postal Code should be 6 digit.");
      } else {
        setIsValid({ ...valid, postalCode: false });
        setPostalError("");
      }
    } else if (e.target.name === "aadhaarNo") {
      if (aadhaarNo !== "" && !validateAadhaar(aadhaarNo)) {
        setIsValid({ ...valid, aadhaarNo: true });
        setAadhaarError("Aadhaar number should be exactly 12 digits");
      } else {
        setIsValid({ ...valid, aadhaarNo: false });
        setAadhaarError("");
      }
    } else if (e.target.name === "passportNo") {
      if (passportNo !== "" && !validatePassportNo(passportNo)) {
        setIsValid({ ...valid, passportNo: true });
        setPassportNoError("Enter a valid passport number (e.g., A1234567 or AB123456)");
      } else {
        setIsValid({ ...valid, passportNo: false });
        setPassportNoError("");
      }
    } else if (e.target.name === "nameOnPassport") {
      if (nameOnPassport === "") {
        setIsValid({ ...valid, nameOnPassport: true });
        setNameOnPassportError("Name on passport is required");
      } else {
        setIsValid({ ...valid, nameOnPassport: false });
        setNameOnPassportError("");
      }
    } else if (e.target.name === "Place of Issue") {
      if (placeOfIssue === "") {
        setIsValid({ ...valid, placeOfIssue: true });
        setPlaceOfIssueError("Place of issue is required");
      } else {
        setIsValid({ ...valid, placeOfIssue: false });
        setPlaceOfIssueError("");
      }
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "name") {
      setName(e.target.value);
      // Clear validation error when user starts typing
      if (e.target.value !== "" && valid.name) {
        setIsValid({ ...valid, name: false });
      }
    } else if (e.target.name === "email") {
      setEmail(e.target.value);
    } else if (e.target.name === "phoneNumber") {
      if (phoneNumber.length === 0 && e.target.value === "0") {
        setPhoneNumber("");
      } else if (e.target.value === "" || e.target.value.length <= 10) {
        setPhoneNumber(e.target.value);
      }
    } else if (e.target.name === "PAN") {
      const upperCaseValue = e.target.value.toUpperCase();
      if (e.target.value.length <= 10) setPanNumber(upperCaseValue);
    }
    // else if (e.target.name === "Relation") {
    //   setStudentRelationship(e.target.value);
    // }
    else if (e.target.name === "Postal") {
      if (e.target.value === "" || e.target.value.length <= 6) {
        setPostalCode(e.target.value);
      }
    } else if (e.target.name === "Address") {
      setAddress(e.target.value);
    } else if (e.target.name === "City") {
      setCity(e.target.value);
    } else if (e.target.name === "State") {
      setState(e.target.value);
    } else if (selectedDocument === "Aadhaar") {
      if (e.target.name === "aadhaarNo") {
        if (e.target.value === "" || e.target.value.length <= 12) {
          setAadhaarNo(e.target.value);
        }
      }
    } else if (selectedDocument === "Passport") {
      if (e.target.name === "nameOnPassport") {
        setNameOnPassport(e.target.value);
      } else if (e.target.name === "passportNo") {
        const upperCaseValue = e.target.value.toUpperCase();
        if (e.target.value.length <= 9) setPassportNo(upperCaseValue);
      } else if (e.target.name === "placeOfIssue") {
        setPlaceOfIssue(e.target.value);
      }
    }
  };

  const checkIfValid = () => {
    setDobError("");
    setSelectedDocumentError("");
    setAadhaarError("");
    setPassportNoError("");
    setNameOnPassportError("");
    setPassportIssueDateError("");
    setPassportExpiryDateError("");
    setPlaceOfIssueError("");

    // Basic field validation
    if (name === "") {
      setIsValid({ ...valid, name: true });
      return;
    } else if (email === "") {
      setIsValid({ ...valid, email: true });
      return;
    } else if (phoneNumber === "") {
      setIsValid({ ...valid, phoneNumber: true });
      return;
    } else if (panNumber === "") {
      setIsValid({ ...valid, panNumber: true });
      return;
    }
    // else if (studentRelationship === "") {
    //   setIsValid({ ...valid, studentRelationship: true });
    //   return;
    // }
    else if (postalCode === "") {
      setIsValid({ ...valid, postalCode: true });
      return;
    } else if (address === "") {
      setIsValid({ ...valid, address: true });
      return;
    } else if (city === "") {
      setIsValid({ ...valid, city: true });
      return;
    } else if (state === "") {
      setIsValid({ ...valid, state: true });
      return;
    } else if (dob === "") {
      setDobError("Please Select Date");
      return;
    }

    // Document selection validation
    if (!selectedDocument) {
      setIsValid({ ...valid, selectedDocument: true });
      setSelectedDocumentError("Please select a document type");
      return;
    }

    // Document-specific field validation
    if (selectedDocument === "Aadhaar") {
      if (aadhaarNo === "") {
        setIsValid({ ...valid, aadhaarNo: true });
        setAadhaarError("Aadhaar number is required");
        return;
      } else if (!validateAadhaar(aadhaarNo)) {
        setIsValid({ ...valid, aadhaarNo: true });
        setAadhaarError("Aadhaar number should be exactly 12 digits");
        return;
      }
    } else if (selectedDocument === "Passport") {
      if (nameOnPassport === "") {
        setIsValid({ ...valid, nameOnPassport: true });
        setNameOnPassportError("Name on passport is required");
        return;
      }
      if (passportNo === "") {
        setIsValid({ ...valid, passportNo: true });
        setPassportNoError("Passport number is required");
        return;
      } else if (!validatePassportNo(passportNo)) {
        setIsValid({ ...valid, passportNo: true });
        setPassportNoError("Enter a valid passport number (e.g., A1234567 or AB123456)");
        return;
      }
      if (placeOfIssue === "") {
        setIsValid({ ...valid, placeOfIssue: true });
        setPlaceOfIssueError("Place of issue is required");
        return;
      }
      if (passportIssueDate === "") {
        setIsValid({ ...valid, passportIssueDate: true });
        setPassportIssueDateError("Passport issue date is required");
        return;
      }
      if (passportExpiryDate === "") {
        setIsValid({ ...valid, passportExpiryDate: true });
        setPassportExpiryDateError("Passport expiry date is required");
        return;
      }
      if (!validatePassportDates(passportIssueDate, passportExpiryDate)) {
        setIsValid({ ...valid, passportExpiryDate: true });
        setPassportExpiryDateError(
          "Invalid passport dates. Issue date should be in the past and expiry date should be in the future",
        );
        return;
      }
    }

    // Check for any existing validation errors based on selected document
    let hasErrors = false;

    // Check common field errors
    if (
      emailError !== "" ||
      phoneNoError !== "" ||
      panError !== "" ||
      dobError !== "" ||
      postalError !== "" ||
      selectedDocumentError !== ""
    ) {
      hasErrors = true;
    }

    // Check document-specific errors
    if (selectedDocument === "Aadhaar" && aadhaarError !== "") {
      hasErrors = true;
    } else if (selectedDocument === "Passport") {
      if (
        passportNoError !== "" ||
        nameOnPassportError !== "" ||
        passportIssueDateError !== "" ||
        passportExpiryDateError !== "" ||
        placeOfIssueError !== ""
      ) {
        hasErrors = true;
      }
    }

    if (hasErrors) {
      setNextSectionError("Please fill all the required fields correctly.");
      return;
    }

    // All validations passed
    setIsValid({
      name: false,
      email: false,
      phoneNumber: false,
      panNumber: false,
      // studentRelationship: false,
      postalCode: false,
      address: false,
      city: false,
      state: false,
      country: false,
      dob: false,
      selectedDocument: false,
      aadhaarNo: false,
      nameOnPassport: false,
      passportNo: false,
      passportIssueDate: false,
      passportExpiryDate: false,
    });
    setNextSectionError("");
    remitterPersonalDetailApi();
  };

  const remitterPersonalDetailApi = () => {
    setLoading(true);
    const remitterPersonalDetailData = async () => {
      const body = {
        name: name,
        address: address,
        city: city,
        state: state,
        country: "India",
        dob: parseDate(dob),
        postalCode: postalCode,
        email: email,
        phone: "+91" + phoneNumber,
        accountType: "Remitter",
        // userClientRefNo: "AGENCY05",
        panNo: panNumber,
        // comment: studentRelationship,
        firstName: name,
        // reason: studentRelationship,
        // relation: studentRelationship,
        remitterType: "Guardian",
      };

      if (selectedDocument === "Aadhaar") {
        body.aadhaarNo = aadhaarNo;
      }

      if (selectedDocument === "Passport") {
        body.passportNo = passportNo;
        body.nameOnPassport = nameOnPassport;
        body.passportIssueDate = parseDate(passportIssueDate);
        body.passportExpiryDate = parseDate(passportExpiryDate);
        body.placeOfIssue = placeOfIssue;
      }

      try {
        onBoardPersonalDetail(body).then((resp) => {
          setLoading(false);
          if (resp.status === 200 && resp.data && resp.data.data) {
            upadteUserId(resp.data.data.userAccountId);
            setRemitterCardSelection(false);
            setShowRemitterDetail(true);
            setRemitterSecondFlow(true);
            setStepsToShow("RemitterStep2");
            setShowModal(false);
            // sessionStorage.setItem("remitterName", name);
            setShortDetail({
              name: name,
              phone: phoneNumber,
              email: email,
              dob: dob,
              address: address,
              city: city,
              state: state,
              postalcode: postalCode,
              country: "India",
              userAccountId: resp.data.data.userAccountId,
            });
            setName("");
            setEmail("");
            setPhoneNumber("");
            setPanNumber("");
            // setStudentRelationship("");
            setPostalCode("");
            setAddress("");
            setCity("");
            setState("");
            setDob("");
            const reqDocs = ["PAN"];
            body.aadhaarNo ? reqDocs.push("Aadhaar") : reqDocs.push("Passport");
            setReqDocs(reqDocs);
          } else {
            setNextSectionError(
              resp && resp.data
                ? resp.data.message
                : "something went wrong, please try again later.",
            );
          }
        });
      } catch (error) {
        setLoading(false);
        setNextSectionError("something went wrong, please try again later.");
      }
    };
    remitterPersonalDetailData();
  };

  const handleChangeNew = (e) => {
    e.preventDefault();
    setRemitterCardSelection(false);
    setStepsToShow("RemitterStep1");
    setShowKyc(true);
    setShowModal(true);
  };

  const handleChangeBack = (e) => {
    e.preventDefault();
    fetchCardDetail();
    setRemitterSecondFlow(true);
    setShowRemitterDetail(false);
    setStepsToShow("");
    setRemitterBankSecondFlow(false);
    setRemitterBankCardSelection(false);
    setSelectedRemitterBank(null);
    setShowRemitterBankDetail(false);
    setCompletedRemitter(false);
    setShowKycDetail(false);
    setKycLoader(false);
    setErrorStatus(false);
    setShowModal(false);
  };

  const handleRemitterSelection = (remitter) => {
    console.log("Selected remitter:", remitter);
    // Handle the selected remitter data here
    // You can populate the form or proceed to the next step
  };

  const formattedRemitterOptions =
    remitterList?.map((remitter) => ({
      value: remitter.userAccountId,
      label: remitter.fullName,
      email: remitter.email,
      phone: remitter.phone,
      fullData: remitter,
    })) || [];

  return (
    <Card className={styles.cardAccount}>
      <Card.Body className={styles.cardBodyAccount}>
        <div className={styles.headingandbutton}>
          <Row className={styles.Title}>Personal Details</Row>
          {remitterSecondFlow === true && remitterLoader === false && (
            <>
              {remitterCardSelection === true ? (
                <div className={styles.HeaderParent}>
                  <SearchableDropdown
                    options={formattedRemitterOptions}
                    setFilteredList={setDisplayRemitterList}
                    label="Search Remitter"
                    onChange={(value, label, option) =>
                      handleRemitterSelection(option?.fullData)
                    }
                    onClear={() => setClearSelectionTrigger((prev) => prev + 1)}
                  />
                  <div
                    className={styles.buttonaddnew}
                    onClick={handleChangeNew}
                  >
                    <AddIcon color="#0061D3" />
                    Add New
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className={
                      showRemitterDetail === false
                        ? styles.buttonback
                        : styles.buttonEdit
                    }
                    onClick={handleChangeBack}
                  >
                    {showRemitterDetail &&
                    (stepToShow === "RemitterStep1" ||
                      stepToShow === "RemitterStep2" ||
                      stepToShow === "RemitterStep3")
                      ? "Edit"
                      : stepToShow === "RemitterStep1"
                        ? "Back"
                        : ""}
                  </div>
                </>
              )}
            </>
          )}
        </div>
        {remitterLoader ? (
          <Spinner
            animation="border"
            className={styles.spinnerColorOutside}
            style={{ borderColor: themeColor, borderRightColor: "#eaecf0" }}
          />
        ) : (
          <>
            {showRemitterDetail === true ? (
              <>
                <Row>
                  <Col md={11} sm={11} xs={10} className={styles.details}>
                    {shortDetail.name}, {shortDetail.phone}, {shortDetail.email}
                    , {shortDetail.dob}, {shortDetail.address},{" "}
                    {shortDetail.city}, {shortDetail.state},{" "}
                    {shortDetail.postalcode}, {shortDetail.country}
                  </Col>
                  <Col md={1} sm={1} xs={2} style={{ position: "relative" }}>
                    <img
                      className={styles.greentick}
                      src={greentickmark}
                      alt=""
                    />
                  </Col>
                </Row>
              </>
            ) : remitterCardSelection === true ? (
              <VisitedRemitter
                setReqDocs={setReqDocs}
                showRemitterDetail={showRemitterDetail}
                setShowRemitterDetail={setShowRemitterDetail}
                remitterList={displayRemitterList}
                shortDetail={shortDetail}
                setShortDetail={setShortDetail}
                setStepsToShow={setStepsToShow}
                remitterCardSelection={remitterCardSelection}
                setRemitterCardSelection={setRemitterCardSelection}
                clearSelectionTrigger={clearSelectionTrigger}
              />
            ) : (
              <>
                {stepToShow === "RemitterStep1" ? (
                  <>
                    <div className={styles.showonWeb}>
                      <hr style={{ marginTop: "0px" }} />
                      <RemitterForm
                        placeOfIssue={placeOfIssue}
                        placeOfIssueError={placeOfIssueError}
                        selectedDocument={selectedDocument}
                        setSelectedDocument={setSelectedDocument}
                        name={name}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        valid={valid}
                        email={email}
                        emailError={emailError}
                        phoneNumber={phoneNumber}
                        phoneNoError={phoneNoError}
                        panNumber={panNumber}
                        panError={panError}
                        // handleChangeOption={handleChangeOption}
                        postalCode={postalCode}
                        postalError={postalError}
                        address={address}
                        city={city}
                        state={state}
                        dob={dob}
                        onHandleDate={onHandleDate}
                        dobError={dobError}
                        nextSectionError={nextSectionError}
                        checkIfValid={checkIfValid}
                        loading={loading}
                        themeColor={themeColor}
                        aadhaarNo={aadhaarNo}
                        aadhaarError={aadhaarError}
                        nameOnPassport={nameOnPassport}
                        nameOnPassportError={nameOnPassportError}
                        passportNo={passportNo}
                        passportNoError={passportNoError}
                        passportIssueDate={passportIssueDate}
                        passportIssueDateError={passportIssueDateError}
                        passportExpiryDate={passportExpiryDate}
                        passportExpiryDateError={passportExpiryDateError}
                        selectedDocumentError={selectedDocumentError}
                      />
                    </div>
                    {screenWidth < 576 && (
                      <>
                        {addnewButton && (
                          <Row>
                            <Col
                              sm={6}
                              xs={6}
                              className={styles.nodatafoundStyling}
                            >
                              No Data Found
                            </Col>
                            <Col sm={6} xs={6}>
                              <Button
                                style={{
                                  margin: "10px 0px",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "14px",
                                }}
                                onClick={() => setShowModal(true)}
                              >
                                Add New
                              </Button>
                            </Col>
                          </Row>
                        )}
                        <Modal
                          show={stepToShow === "RemitterStep1" && showModal}
                        >
                          <div style={{ padding: "20px" }}>
                            <Row>
                              <Col
                                md={9}
                                sm={9}
                                xs={9}
                                className={styles.Title}
                              >
                                Personal Details
                              </Col>
                              <Col
                                md={3}
                                sm={3}
                                xs={3}
                                onClick={
                                  addnewButton
                                    ? () => setShowModal(false)
                                    : handleChangeBack
                                }
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  padding: "10px",
                                }}
                              >
                                <img src={cross} alt="nav-close" />
                              </Col>
                            </Row>
                            <hr style={{ marginTop: "0px" }} />
                            <RemitterForm
                              placeOfIssueError={placeOfIssueError}
                              placeOfIssue={placeOfIssue}
                              setPlaceOfIssue={setPlaceOfIssue}
                              name={name}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              valid={valid}
                              email={email}
                              emailError={emailError}
                              phoneNumber={phoneNumber}
                              phoneNoError={phoneNoError}
                              panNumber={panNumber}
                              panError={panError}
                              // handleChangeOption={handleChangeOption}
                              postalCode={postalCode}
                              postalError={postalError}
                              address={address}
                              city={city}
                              state={state}
                              dob={dob}
                              onHandleDate={onHandleDate}
                              dobError={dobError}
                              nextSectionError={nextSectionError}
                              checkIfValid={checkIfValid}
                              loading={loading}
                              themeColor={themeColor}
                            />
                          </div>
                        </Modal>
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}
              </>
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default RemitterPersonalDetail;
